(() => {
  const shuffle = items => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  async function loadProducts(grid) {
    if (grid.dataset.inventorySnapshot) {
      const response = await fetch(grid.dataset.inventorySnapshot);
      if (!response.ok) throw new Error('Inventory unavailable');
      return (await response.json()).products;
    }
    const products = [];
    for (let page = 1; ; page++) {
      const url = new URL(`${grid.dataset.inventoryCollection}/products.json`, location.origin);
      url.searchParams.set('limit', '250');
      url.searchParams.set('page', String(page));
      const response = await fetch(url);
      if (!response.ok) throw new Error('Inventory unavailable');
      const data = await response.json();
      if (!Array.isArray(data.products)) throw new Error('Invalid inventory');
      products.push(...data.products);
      if (data.products.length < 250) return products;
    }
  }
  function card(product, grid) {
    const available = product.variants.some(variant => variant.available);
    const article = document.createElement('article');
    article.className = 'product-card';
    article.dataset.type = /milk/i.test(product.product_type) ? 'milk' : 'king';
    const link = document.createElement('a');
    const base = grid.dataset.productBase || '';
    link.href = `${base}/products/${encodeURIComponent(product.handle)}`;
    const media = document.createElement('div');
    media.className = 'product-image';
    if (product.images[0]) {
      const image = document.createElement('img');
      image.src = product.images[0].src;
      image.alt = product.images[0].alt || product.title;
      image.loading = 'lazy';
      image.width = product.images[0].width || 900;
      image.height = product.images[0].height || 900;
      media.append(image);
    }
    if (available) {
      const badge = document.createElement('span');
      badge.textContent = 'Available';
      media.append(badge);
    }
    const meta = document.createElement('div');
    meta.className = 'product-meta';
    const vendor = document.createElement('p');
    vendor.textContent = product.vendor;
    const title = document.createElement('h3');
    title.textContent = product.title;
    const detail = document.createElement('p');
    detail.className = 'trait';
    const description = new DOMParser().parseFromString(product.body_html || '', 'text/html').body.textContent.trim().replace(/\s+/g, ' ');
    detail.textContent = description.length > 72 ? `${description.slice(0, 69)}…` : description;
    const price = document.createElement('strong');
    const values = product.variants.map(variant => Number(variant.price));
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency', currency: grid.dataset.currency || 'CAD', currencyDisplay: 'code'
    }).format(Math.min(...values));
    meta.append(vendor, title, detail, price);
    link.append(media, meta);
    article.append(link);
    return article;
  }
  async function refresh(grid) {
    try {
      let products = await loadProducts(grid);
      if (grid.dataset.availableOnly === 'true') products = products.filter(product => product.variants.some(variant => variant.available));
      shuffle(products);
      const limit = Number(grid.dataset.inventoryLimit);
      if (limit) products = products.slice(0, limit);
      const fragment = document.createDocumentFragment();
      products.forEach(product => fragment.append(card(product, grid)));
      if (!products.length) {
        const empty = document.createElement('p');
        empty.textContent = 'No animals are available right now. Please check back soon.';
        fragment.append(empty);
      }
      grid.replaceChildren(fragment);
    } catch (error) {
      // Keep the server-rendered listings and pagination usable if inventory cannot load.
      const cards = shuffle([...grid.querySelectorAll('.product-card')]);
      const pagination = grid.querySelector('.pagination');
      cards.forEach(item => grid.insertBefore(item, pagination));
    }
  }
  const refreshAll = () => document.querySelectorAll('[data-random-inventory]').forEach(refresh);
  refreshAll();
  window.addEventListener('pageshow', event => { if (event.persisted) refreshAll(); });
  document.addEventListener('shopify:section:load', refreshAll);
})();
